import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';
import { isInEnum } from '@thesavingsgroup/utils/isInEnum';

import { RefinanceGoal } from '../enums/RefinanceGoal';
import { SearchVehicle } from '../enums/SearchVehicle';
import { ApplyState } from '../types/ApplyState';
import { HydrateFromSignUp } from '../types/HydrateFromSignUp';
import { VehicleIdentifiers } from '../types/VehicleIdentifiers';
import { isValidVin } from './isValidVin';

export const toApplyStateFromSignUp = async (
  signUp: HydrateFromSignUp,
  findVehicleByVin: (vin: string) => Promise<VehicleIdentifiers | null>,
): Promise<Partial<ApplyState>> => {
  const applicationType = isInEnum(signUp.applicationType, ApplicationType)
    ? signUp.applicationType
    : null;

  const isRefinance = applicationType === ApplicationType.REFINANCE;

  const vin = isValidVin(signUp.vin) ? signUp.vin : null;

  const refinanceGoal: RefinanceGoal | null =
    isRefinance && vin ? RefinanceGoal.LOWER_PAYMENT : null;

  const searchVehicle: SearchVehicle | null = vin ? SearchVehicle.BY_VIN : null;

  const vehicle = vin ? await findVehicleByVin(vin) : null;

  const make = vehicle?.make || null;
  const model = vehicle?.model || null;
  const trim = vehicle?.trim || null;
  const year = vehicle?.year || null;

  return {
    applicationType,
    make,
    model,
    refinanceGoal,
    searchVehicle,
    trim,
    vin,
    year,
  };
};
